import React from 'react'
import { Navbar, Container, Nav} from 'react-bootstrap'
import { BsPersonCircle } from 'react-icons/bs';
import { SearchBar } from '../components/SearchBar';

import { signOut } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from '../index';

function ToolBar(props) {
    const [user, loading, error] = useAuthState(auth);
    return (
        <Navbar bg={!props.home ? "primary" : "transparent"} variant={!props.home ? "dark" : "light"} className="py-3">
            <Container >
                {!props.home && 
                    <>
                        <Navbar.Brand href="/">
                            <img
                                alt=""
                                src="../../logo.svg"
                                width="40"
                                height="40"
                                className="d-inline-block align-center text-primary"
                            />{' '}
                            FratRank
                        </Navbar.Brand>
                        <SearchBar nav={"redirect"} />
                    </>
                }
                <Nav className='align-self-center justify-content-end flex-grow-1'>
                    {
                        !user &&
                        <Nav.Link href="/login" className={!props.home ? "text-light" : ""}>
                            <div>Login</div>      
                        </Nav.Link>
                    }
                    {
                        user &&
                        <>
                        <Nav.Link href="/profile" className={!props.home ? "text-light" : ""}>
                            { auth.currentUser.email }&nbsp;
                            <BsPersonCircle />
                        </Nav.Link>
                        <Nav.Link href="/" onClick={() => {signOut(auth)}} className={!props.home ? "text-light" : ""}>
                            <div>Logout</div>      
                        </Nav.Link>
                        </>
                    }
                </Nav>
            </Container>
        </Navbar>
    );
}

export { ToolBar }